import logo from '../assets/logo.png';
import background from '../assets/bg3.jpg';
const CoverSection1 = ({ fullName }) => {
    return (
        <div className="section cover-section" style={{ backgroundImage: `url(${background})` }}>
            <div>
                <p className="w300">{fullName ? 'Dear,' : ''}</p>
                <p className="w500">{fullName || ''}</p>
                <img src={logo} className="logo" alt="logo" />
            </div>
            <div className="bottom-wrapper">
                <div className="icon-scroll" />
            </div>
        </div>
    );
};

export default CoverSection1;
